import { createContext } from 'react';

export const ConnectionContext = createContext();
